module.exports = __webpack_public_path__ + "static/media/26130021-VeUzwSgs.b24746db.JPG";